import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-[#1c2b38] text-white">
      <div className="max-w-7xl mx-auto px-6 py-16 grid grid-cols-1 md:grid-cols-3 gap-10">
        {/* Brand */}
        <div className="flex flex-col gap-4">
          <img
            src="https://public.readdy.ai/ai/img_res/01fc393c-308e-40a9-91b4-843ac2a4212b.png"
            alt="Juárez Logo"
            className="h-16 w-auto object-contain"
          />
          <p className="text-gray-400 text-sm leading-relaxed">
            Empresa líder en arriendo de maquinaria y grúas plumas en la Región de Coquimbo desde el año 2001.
          </p>
          <div className="flex gap-3 mt-2">
            <a href="mailto:chj@charlesjuarez.cl" className="w-9 h-9 flex items-center justify-center rounded-full bg-white/10 hover:bg-orange-500 transition-colors cursor-pointer">
              <i className="ri-mail-line text-sm" />
            </a>
            <a href="tel:512247995" className="w-9 h-9 flex items-center justify-center rounded-full bg-white/10 hover:bg-orange-500 transition-colors cursor-pointer">
              <i className="ri-phone-line text-sm" />
            </a>
            <a href="https://www.instagram.com/gruas_maestranza_juarez/" target="_blank" rel="nofollow noopener noreferrer" className="w-9 h-9 flex items-center justify-center rounded-full bg-white/10 hover:bg-pink-500 transition-colors cursor-pointer">
              <i className="ri-instagram-line text-sm" />
            </a>
          </div>
        </div>

        {/* Navigation */}
        <div>
          <h4 className="text-orange-400 uppercase text-xs font-bold tracking-widest mb-5">Navegación</h4>
          <ul className="flex flex-col gap-3">
            {[
              { label: "Quiénes Somos", to: "/" },
              { label: "Arriendo de Maquinarias", to: "/arriendo-maquinarias" },
              { label: "Contacto", to: "/contacto" },
            ].map((link) => (
              <li key={link.to}>
                <Link
                  to={link.to}
                  className="text-gray-400 text-sm hover:text-orange-400 transition-colors cursor-pointer"
                >
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Contact */}
        <div>
          <h4 className="text-orange-400 uppercase text-xs font-bold tracking-widest mb-5">Contacto</h4>
          <ul className="flex flex-col gap-3 text-gray-400 text-sm">
            <li className="flex items-start gap-2">
              <i className="ri-map-pin-line text-orange-400 mt-0.5" />
              <span>Av. Molino 1260, Barrio Industrial, Coquimbo</span>
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-mail-line text-orange-400" />
              <a href="mailto:chj@charlesjuarez.cl" className="hover:text-orange-400 transition-colors">chj@charlesjuarez.cl</a>
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-phone-line text-orange-400" />
              <a href="tel:512247995" className="hover:text-orange-400 transition-colors">51 2 247995</a>
            </li>
          </ul>
        </div>
      </div>

      {/* Instagram Banner */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 flex items-center justify-center rounded-full bg-gradient-to-br from-[#f9a825] via-[#e1306c] to-[#833ab4] shrink-0">
              <i className="ri-instagram-line text-white text-lg" />
            </div>
            <div>
              <p className="text-white font-semibold text-sm">Síguenos en Instagram</p>
              <p className="text-gray-400 text-xs">Mira nuestros trabajos y equipos en acción</p>
            </div>
          </div>
          <a
            href="https://www.instagram.com/gruas_maestranza_juarez/"
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="whitespace-nowrap flex items-center gap-2 px-5 py-2.5 rounded-full bg-gradient-to-r from-[#f9a825] via-[#e1306c] to-[#833ab4] text-white text-sm font-semibold hover:opacity-90 transition-opacity cursor-pointer"
          >
            <i className="ri-instagram-line text-base" />
            @gruas_maestranza_juarez
          </a>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="text-gray-500 text-xs">© 2025 Charles Juárez. Todos los derechos reservados.</p>
          <p className="text-gray-600 text-xs">Coquimbo, Chile</p>
        </div>
      </div>
    </footer>
  );
}
